import React, { useState, useEffect } from "react";
import { auth } from "../firebase"; // Import Firebase authentication instance
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import RainbowBeard from "../images/rainbow-beard.jpg";
import { FaQuestionCircle } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";

const SignIn = ({ user, setUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    // Use onAuthStateChanged to listen for changes in the authentication state
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        // User is signed in, set the user state
        setUser(authUser);
      } else {
        // User is signed out, clear the user state
        setUser(null);
      }
    });

    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, [setUser]);

  const handleSignIn = async () => {
    try {
      // Sign a new user with email and password using Firebase authentication
      const userCred = await signInWithEmailAndPassword(auth, email, password);
      console.log("userCred is:", userCred);
      const userUid = userCred.user.uid;
      console.log("From signIn.js UserUid is,", userUid);
      console.log("Email is:", userCred.user.email);
      sessionStorage.setItem("email", userCred.user.email);
      setUser(userCred); // You don't need to set the user here; it will be set by the listener
      console.log("From SignIn, userUid is ", userUid);
      console.log("From SignIn, userCred is ", userCred);
      navigate("/UserProfile");
    } catch (error) {
      setError(error);
      console.error("Firebase Error:", error.code, error.message);
    }
  };

  return (
    <>
      <Container className='mt-4'>
        <Row className='mt3 d-flex align-items-center'>
          <Col lg={6} className='whiteText mt-4 '>
            <h2>Sign In</h2>
            {user && <p>Signed in as: {user.email} </p>}
            {error && <p style={{ color: "red" }}>{error.message}</p>}
            <Form>
              <Form.Group controlId='formBasicEmail'>
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type='email'
                  placeholder='Enter email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group controlId='formBasicPassword'>
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>
              <Row>
                <Col>
                  <Button
                    className='btn btn-primary mb-4'
                    onClick={handleSignIn}>
                    Sign In
                  </Button>
                </Col>
                <Col>
                  <Link
                    className='d-flex justify-content-end align-items-center edit-link'
                    to='/ForgotPassword'>
                    Forgot Password?
                    {<FaQuestionCircle size={"18"} className='gallery-icon' />}
                  </Link>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col lg={6} className='text-center'>
            <img
              src={RainbowBeard}
              alt='Artist Showcase'
              className='img-fluid'
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SignIn;
